import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {BrowserRouter} from "react-router-dom";
import './index.css'

import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App.tsx'
import { initKeycloakAuth, login, isAuthenticated } from './auth/KeycloakAuth';
import { isDebug } from './base/utils/GeneralUtilities';

(async () => {
    try {
        await initKeycloakAuth();
        if (!isAuthenticated() && !isDebug()) {
            // Trigger interactive login (redirect) if not authenticated and not in debug mode
            await login();
            // After login redirect the app will re-run this bootstrap code.
        }
    } catch (e) {
        // Log initialization issue; app still renders (unauthenticated state)
        console.error('Auth initialization error', e);
    }

    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <BrowserRouter basename={'/'}>
                <App/>
            </BrowserRouter>
        </StrictMode>
    );
})();
